import React from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import cn from 'classnames';
import classes from './Tooltip.module.scss';

const DefaultColor = '#3A4861';

export const Tooltip = (props) => {
  const { color = DefaultColor, overlayClassName, ...rest } = props;

  return (
    <AntdTooltip overlayClassName={cn(classes.tooltip, overlayClassName)} color={color} {...rest} />
  );
};
